import { Link } from '@raisin/components-lib';
import styled from 'styled-components';
export const Background = styled('div')(({ theme }) => ({
    marginBottom: theme.spacing(5),
    backgroundColor: theme.palette.black10.main,
}));
export const Wrapper = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(7, 0),
    [theme.breakpoints.down('md')]: {
        padding: theme.spacing(5, 0),
        flexDirection: 'column',
    },
}));
export const InnerWrapper = styled('div')(({ theme }) => ({
    display: 'flex',
    [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        marginBottom: theme.spacing(2.5),
    },
}));
export const ContactInfo = styled('span')(({ theme }) => ({
    marginRight: theme.spacing(4),
}));
export const ContactLink = styled(Link)(({ theme }) => ({
    textDecoration: 'none',
    '&:hover': {
        color: theme.palette.blue60.main,
    },
}));
//# sourceMappingURL=styles.js.map